/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EditorDoc } from '../models/EditorDoc';
import type { EditorDocAdmin } from '../models/EditorDocAdmin';
import type { EditorDocFreeformResource } from '../models/EditorDocFreeformResource';
import type { EditorDocFreeformResourceCreate } from '../models/EditorDocFreeformResourceCreate';
import type { EditorDocStrategyAssociation } from '../models/EditorDocStrategyAssociation';
import type { EditorDocStrategyAssociationCreate } from '../models/EditorDocStrategyAssociationCreate';
import type { EditorDocStrategyAssociationUpdate } from '../models/EditorDocStrategyAssociationUpdate';
import type { EditorDocTemplateResourceName } from '../models/EditorDocTemplateResourceName';
import type { EditorDocTemplateResourceUpdate } from '../models/EditorDocTemplateResourceUpdate';
import type { EditorDocUpdate } from '../models/EditorDocUpdate';
import type { EditorWorkstreamAssociation } from '../models/EditorWorkstreamAssociation';
import type { LivePlanningAdminResponse } from '../models/LivePlanningAdminResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EditordocService {

    /**
     * Create
     * @param type
     * @returns EditorDoc Successful Response
     * @throws ApiError
     */
    public static createApiV1EditordocPost(
        type: string,
    ): CancelablePromise<EditorDoc> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/editordoc',
            query: {
                'type': type,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Narratives
     * @returns EditorDoc Successful Response
     * @throws ApiError
     */
    public static getNarrativesApiV1EditordocNarrativesGet(): CancelablePromise<Array<EditorDoc>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/editordoc/narratives',
        });
    }

    /**
     * Get Employee Docs
     * @param scope
     * @returns EditorDoc Successful Response
     * @throws ApiError
     */
    public static getEmployeeDocsApiV1EditordocDocsGet(
        scope: 'my' | 'all' = 'my',
    ): CancelablePromise<Array<EditorDoc>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/editordoc/docs',
            query: {
                'scope': scope,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Employee Docs Admin
     * @returns EditorDocAdmin Successful Response
     * @throws ApiError
     */
    public static getEmployeeDocsAdminApiV1EditordocAllGet(): CancelablePromise<Array<EditorDocAdmin>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/editordoc/all',
        });
    }

    /**
     * Get Live Planning Docs Admin
     * @returns LivePlanningAdminResponse Successful Response
     * @throws ApiError
     */
    public static getLivePlanningDocsAdminApiV1EditordocLiveAdminGet(): CancelablePromise<LivePlanningAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/editordoc/live-admin',
        });
    }

    /**
     * Get
     * Get editor document by ID.
     * @param encryptedId
     * @returns EditorDoc Successful Response
     * @throws ApiError
     */
    public static getApiV1EditordocEncryptedIdGet(
        encryptedId: string,
    ): CancelablePromise<EditorDoc> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/editordoc/{encrypted_id}',
            path: {
                'encrypted_id': encryptedId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update
     * @param encryptedId
     * @param requestBody
     * @returns EditorDoc Successful Response
     * @throws ApiError
     */
    public static updateApiV1EditordocEncryptedIdPut(
        encryptedId: string,
        requestBody: EditorDocUpdate,
    ): CancelablePromise<EditorDoc> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/editordoc/{encrypted_id}',
            path: {
                'encrypted_id': encryptedId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete
     * @param encryptedId
     * @returns EditorDoc Successful Response
     * @throws ApiError
     */
    public static deleteApiV1EditordocEncryptedIdDelete(
        encryptedId: string,
    ): CancelablePromise<EditorDoc> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/editordoc/{encrypted_id}',
            path: {
                'encrypted_id': encryptedId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Workstreams
     * @param encryptedId
     * @returns EditorWorkstreamAssociation Successful Response
     * @throws ApiError
     */
    public static getWorkstreamsApiV1EditordocEncryptedIdWorkstreamsGet(
        encryptedId: string,
    ): CancelablePromise<Array<EditorWorkstreamAssociation>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/editordoc/{encrypted_id}/workstreams',
            path: {
                'encrypted_id': encryptedId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Workstreams
     * @param encryptedId
     * @param contributingWorkstreamId
     * @param workstreamType
     * @param action
     * @param requestBody
     * @returns EditorWorkstreamAssociation Successful Response
     * @throws ApiError
     */
    public static workstreamsApiV1EditordocEncryptedIdWorkstreamsPut(
        encryptedId: string,
        contributingWorkstreamId?: (number | null),
        workstreamType: 'narrative' | 'contributing_narrative' = 'narrative',
        action: 'add' | 'remove' | 'add_contributing_id' | 'remove_contributing_id' = 'add',
        requestBody?: Array<number>,
    ): CancelablePromise<Array<EditorWorkstreamAssociation>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/editordoc/{encrypted_id}/workstreams',
            path: {
                'encrypted_id': encryptedId,
            },
            query: {
                'contributing_workstream_id': contributingWorkstreamId,
                'workstream_type': workstreamType,
                'action': action,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Upsert Template Resource
     * @param encryptedId
     * @param requestBody
     * @returns EditorDoc Successful Response
     * @throws ApiError
     */
    public static upsertTemplateResourceApiV1EditordocEncryptedIdResourcesTemplatePost(
        encryptedId: string,
        requestBody: EditorDocTemplateResourceUpdate,
    ): CancelablePromise<EditorDoc> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/editordoc/{encrypted_id}/resources/template',
            path: {
                'encrypted_id': encryptedId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Template Resource
     * @param resourceName
     * @param encryptedId
     * @returns void
     * @throws ApiError
     */
    public static deleteTemplateResourceApiV1EditordocEncryptedIdResourcesTemplateResourceNameDelete(
        resourceName: EditorDocTemplateResourceName,
        encryptedId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/editordoc/{encrypted_id}/resources/template/{resource_name}',
            path: {
                'resource_name': resourceName,
                'encrypted_id': encryptedId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Freeform Resource
     * @param encryptedId
     * @param requestBody
     * @returns EditorDocFreeformResource Successful Response
     * @throws ApiError
     */
    public static createFreeformResourceApiV1EditordocEncryptedIdResourcesFreeformPost(
        encryptedId: string,
        requestBody: EditorDocFreeformResourceCreate,
    ): CancelablePromise<EditorDocFreeformResource> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/editordoc/{encrypted_id}/resources/freeform',
            path: {
                'encrypted_id': encryptedId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Freeform Resource
     * @param resourceId
     * @param encryptedId
     * @param requestBody
     * @returns EditorDocFreeformResource Successful Response
     * @throws ApiError
     */
    public static updateFreeformResourceApiV1EditordocEncryptedIdResourcesFreeformResourceIdPut(
        resourceId: number,
        encryptedId: string,
        requestBody: EditorDocFreeformResourceCreate,
    ): CancelablePromise<EditorDocFreeformResource> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/editordoc/{encrypted_id}/resources/freeform/{resource_id}',
            path: {
                'resource_id': resourceId,
                'encrypted_id': encryptedId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Freeform Resource
     * @param resourceId
     * @param encryptedId
     * @returns void
     * @throws ApiError
     */
    public static deleteFreeformResourceApiV1EditordocEncryptedIdResourcesFreeformResourceIdDelete(
        resourceId: number,
        encryptedId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/editordoc/{encrypted_id}/resources/freeform/{resource_id}',
            path: {
                'resource_id': resourceId,
                'encrypted_id': encryptedId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Strategy Association
     * @param encryptedId
     * @param requestBody
     * @returns EditorDocStrategyAssociation Successful Response
     * @throws ApiError
     */
    public static createStrategyAssociationApiV1EditordocEncryptedIdStrategiesPost(
        encryptedId: string,
        requestBody: EditorDocStrategyAssociationCreate,
    ): CancelablePromise<EditorDocStrategyAssociation> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/editordoc/{encrypted_id}/strategies',
            path: {
                'encrypted_id': encryptedId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Strategy Associations
     * @param encryptedId
     * @returns EditorDocStrategyAssociation Successful Response
     * @throws ApiError
     */
    public static getStrategyAssociationsApiV1EditordocEncryptedIdStrategiesGet(
        encryptedId: string,
    ): CancelablePromise<Array<EditorDocStrategyAssociation>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/editordoc/{encrypted_id}/strategies',
            path: {
                'encrypted_id': encryptedId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Strategy Association
     * @param strategyId
     * @param encryptedId
     * @param requestBody
     * @returns EditorDocStrategyAssociation Successful Response
     * @throws ApiError
     */
    public static updateStrategyAssociationApiV1EditordocEncryptedIdStrategiesStrategyIdPut(
        strategyId: number,
        encryptedId: string,
        requestBody: EditorDocStrategyAssociationUpdate,
    ): CancelablePromise<EditorDocStrategyAssociation> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/editordoc/{encrypted_id}/strategies/{strategy_id}',
            path: {
                'strategy_id': strategyId,
                'encrypted_id': encryptedId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Strategy Association
     * @param strategyId
     * @param encryptedId
     * @returns EditorDocStrategyAssociation Successful Response
     * @throws ApiError
     */
    public static deleteStrategyAssociationApiV1EditordocEncryptedIdStrategiesStrategyIdDelete(
        strategyId: number,
        encryptedId: string,
    ): CancelablePromise<EditorDocStrategyAssociation> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/editordoc/{encrypted_id}/strategies/{strategy_id}',
            path: {
                'strategy_id': strategyId,
                'encrypted_id': encryptedId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Notify For Mention
     * @param encryptedId
     * @param employeeId
     * @param mentionNodeId
     * @param commentPreview
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static notifyForMentionApiV1EditordocEncryptedIdNotifyPost(
        encryptedId: string,
        employeeId: string,
        mentionNodeId: string,
        commentPreview?: (string | null),
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/editordoc/{encrypted_id}/notify',
            path: {
                'encrypted_id': encryptedId,
            },
            query: {
                'employee_id': employeeId,
                'mention_node_id': mentionNodeId,
                'comment_preview': commentPreview,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
